import { MutationTree } from "vuex";
import { Recipes } from "@/types/recipes";
import {
  HomeState,
  Banners,
  InformationServices,
  FavoriteRecipeClips,
  FoodRecommendationList,
  OneMenuRecommendation
} from "@/types/home";
import NativeClient from "@/client/native-client";

const mutations: MutationTree<HomeState> = {
  updateRecommendRecipes: (state, recipes: Recipes | null) => {
    state.recommendRecipes = recipes;
  },
  updateRankingRecipes: (state, recipes: Recipes | null) => {
    state.rankingRecipes = recipes;
  },
  updateBannerPosition: (state, position: number) => {
    state.bannerPosition = position;
  },
  updateBanners: (state, banners: Banners | null) => {
    state.banners = banners;
  },
  updateInformationServices: (state, services: InformationServices | null) => {
    state.services = services;
  },
  updateRecentMyList: (state, clips: FavoriteRecipeClips | null) => {
    state.recentMyList = clips;
  },
  updateMyList: (state, clips: FavoriteRecipeClips | null) => {
    if (clips && clips.clips && state.myList) {
      const mergedMylist = state.myList.clips.concat(clips.clips);
      const newMylist: FavoriteRecipeClips = {
        ...clips,
        clips: mergedMylist
      };
      state.myList = newMylist;
      if (state.myList != null) {
        NativeClient.sendDebugLog(
          "updateMyList add count=" + state.myList.clips.length
        );
      }
      return;
    }
    state.myList = clips;
    if (state.myList != null) {
      NativeClient.sendDebugLog(
        "updateMyList new count=" + state.myList.clips.length
      );
    }
  },
  updateFoodRecommendationList: (
    state,
    foodRecommendationList: FoodRecommendationList | null
  ) => {
    state.foodRecommendationList = foodRecommendationList;
  },
  updateOneMenuRecommendation: (
    state,
    oneMenuRecommendation: OneMenuRecommendation | null
  ) => {
    state.oneMenuRecommendation = oneMenuRecommendation;
  }
};

export default mutations;
